export class ValidationDialogModel {
    constructor(public message: string , public error ? : Array<string>){ }
}